import { customerSlice } from "./customerSlice";
import * as defaultActions from "../../../../../redux/_common";

const { actions } = customerSlice;
const moduleUrl = '/api/pricing/pricingConditions/customer'

export const setValidationErrors = actions.setValidationErrors;

export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);
export const clearItem = () => defaultActions.clearItem(actions);
export const clear = () => defaultActions.clearAll(actions);